export class UserAdd {
    public AdminUserPNumber : string;
    public UserPNumber : string;
    public UserType : string;
}
